interface RouteDiagnosticSource {
  name?: string | symbol | null;
  matched?: readonly { path: string }[];
}

export interface RouteDiagnosticDetails {
  name?: string;
  path?: string;
}

export function routeDiagnosticDetails(
  route: RouteDiagnosticSource,
): RouteDiagnosticDetails {
  const name = route.name;
  const path = route.matched?.at(-1)?.path;
  return {
    ...(name === undefined || name === null ? {} : { name: String(name) }),
    ...(path ? { path } : {}),
  };
}
